// extracted by mini-css-extract-plugin
export var box = "Header-module--box--f2321";
export var layout = "Header-module--layout--499ea";
export var box_md = "Header-module--box_md--6c033";
export var box_xmd = "Header-module--box_xmd--9e1d8";
export var box_flex = "Header-module--box_flex--b49fc";
export var box_lg = "Header-module--box_lg--1bc6b";
export var box_sm = "Header-module--box_sm--fd44e";
export var box_outer = "Header-module--box_outer--d9824";
export var box_whiteBg = "Header-module--box_white-bg--948cb";
export var box_noMarginBottom = "Header-module--box_no-margin-bottom--01ffa";
export var box_noPadding = "Header-module--box_no-padding--551aa";
export var box_outerGray = "Header-module--box_outer-gray--2e4d4";
export var box_dark = "Header-module--box_dark--18229";
export var box_zIndex = "Header-module--box_z-index--6de2e";
export var box_zIndex6 = "Header-module--box_z-index-6--ecf77";
export var box_eventsWithLine = "Header-module--box_events-with-line--92b96";
export var box_featuresAo = "Header-module--box_features-ao--57c7c";
export var box_verticalPaddings = "Header-module--box_vertical-paddings--18eb1";
export var clearP = "Header-module--clearP--ef69a";
export var clearP_vc = "Header-module--clearP_vc--02eaa";
export var header = "Header-module--header--357cc";
export var fixed = "Header-module--fixed--39e53";
export var logoWrap = "Header-module--logoWrap--e3ae4";
export var logo = "Header-module--logo--edb3a";
export var navigation = "Header-module--navigation--acbc9";
export var touchPanel = "Header-module--touchPanel--5457b";
export var fadeInAnimation = "Header-module--fadeInAnimation--37baf";
export var placeHolderShimmer = "Header-module--placeHolderShimmer--17308";